export const RATE_LIMIT_FALLBACK_MESSAGE =
  "You have reached the maximum number of requests allowed. Please wait before trying again.";

const RATE_LIMIT_HINTS = [
  "rate limit",
  "rate_limit",
  "rate-limit",
  "rate_limit_error",
  "rate_limit_exceeded",
  "rate-limit-error",
];

export const extractRateLimitMessageFromResponse = async (response) => {
  console.log(response.error);
  if (!response || (response.status !== 429 && response.status !== 500)) {
    return null;
  }

  let bodyText = "";
  try {
    bodyText = await response.clone().text();
  } catch {
    bodyText = "";
  }

  const normalizedBody = bodyText?.toLowerCase() ?? "";
  const hintsRateLimit =
    response.status === 429 ||
    RATE_LIMIT_HINTS.some((hint) => normalizedBody.includes(hint));

  if (!hintsRateLimit) {
    return null;
  }

  let parsedMessage = "";
  if (bodyText) {
    const trimmed = bodyText.trim();
    const jsonStart = trimmed.indexOf("{");
    if (jsonStart >= 0) {
      const jsonLike = trimmed.slice(jsonStart).replace(/'/g, '"');
      try {
        const parsed = JSON.parse(jsonLike);
        parsedMessage =
          parsed?.message ||
          parsed?.error ||
          parsed?.detail ||
          parsed?.description ||
          "";
      } catch {
        // Ignore parse errors and fall back to regex extraction
      }
    }

    if (!parsedMessage) {
      const doubleQuoteMatch = bodyText.match(/"message"\s*:\s*"([^"]+)"/i);
      const singleQuoteMatch = bodyText.match(/'message':\s*'([^']+)'/i);
      if (doubleQuoteMatch) {
        parsedMessage = doubleQuoteMatch[1];
      } else if (singleQuoteMatch) {
        parsedMessage = singleQuoteMatch[1];
      }
    }
  }

  if (!parsedMessage && normalizedBody.includes("evaluation error")) {
    parsedMessage = "Rate limit exceeded. Please try again later.";
  }
  console.log(parsedMessage);
  return RATE_LIMIT_FALLBACK_MESSAGE;
};
